
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cDvK1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ba6157eb02063535$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $ba6157eb02063535$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': "\u540D\u79F0\u672A\u8A2D\u5B9A\u306E\u30DA\u30FC\u30B8",
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "\u65B0\u3057\u3044\u30DA\u30FC\u30B8\u3092\u4F5C\u6210\u3057\u3001\u30EA\u30F3\u30AF\u3068\u3057\u3066\u633F\u5165\u3057\u307E\u3059",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': "Confluence \u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': "Confluence \u3067\u958B\u304F",
    'editorExtensionLinkCreate.confluencePage.successFlag.description': "\u30DA\u30FC\u30B8\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F",
    'editorExtensionLinkCreate.confluencePage.successFlag.title': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F",
    'editorExtensionLinkCreate.confluencePage.title': "\u65B0\u3057\u3044\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'editorExtensionLinkCreate.genericError.description': "\u30DA\u30FC\u30B8\u3092\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    'editorExtensionLinkCreate.genericError.title': "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': "\u8AB2\u984C\u3092\u30A4\u30F3\u30E9\u30A4\u30F3\u3067\u4F5C\u6210\u3057\u3001\u30EA\u30F3\u30AF\u3068\u3057\u3066\u633F\u5165\u3057\u307E\u3059",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': "Jira \u8AB2\u984C\u3092\u4F5C\u6210",
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': "Jira \u3067\u958B\u304F",
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': "\u8AB2\u984C\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F",
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': "\u8AB2\u984C\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F",
    'editorExtensionLinkCreate.jiraIssue.title': "\u65B0\u3057\u3044\u8AB2\u984C\u3092\u4F5C\u6210\u3059\u308B",
    'editorExtensionLinkCreate.keyword.create': "\u4F5C\u6210\u3059\u308B",
    'editorExtensionLinkCreate.keyword.issue': "\u8AB2\u984C",
    'editorExtensionLinkCreate.keyword.new': "\u65B0\u898F",
    'editorExtensionLinkCreate.keyword.page': "\u30DA\u30FC\u30B8",
    'editorExtensionLinkCreate.keyword.publish': "\u516C\u958B\u3059\u308B",
    'editorExtensionLinkCreate.keyword.raise': "\u767B\u9332\u3059\u308B",
    'editorExtensionLinkCreate.keyword.space': "\u30B9\u30DA\u30FC\u30B9",
    'editorExtensionLinkCreate.keyword.ticket': "\u30C1\u30B1\u30C3\u30C8"
};

});


//# sourceMappingURL=ja.89ba4ad7.js.map
